import { InjectionToken } from '@angular/core';
import { StateSyncSettings } from './sync/state-sync-settings';

export const R_STATE_SYNC_SETTINGS = new InjectionToken<StateSyncSettings>('R_STATE_SYNC_SETTINGS');
